/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...

$(document).ready(function(){$('.js-header-sub-link-a, .js-header-sub-t-a').unbind("click");});